module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/9caa8904100c41fd292e0389ee98780e.png";